import type { GridColDef } from "@mui/x-data-grid-premium";
import type { DecisionOptionButton_DocumentItemFragment } from "../../doc-items/fields/DecisionOptionRadioOrCheckbox.generated.js";
import { DataGridDecisionOptionCell } from "../cells/DataGridDecisionOptionCell.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { ToggleDecisionOptionFn } from "../useDecisionOptionToggle.js";
import type { DocDataGridRow } from "../types.js";

interface Options {
  headerName: string;
  canEdit: boolean;
  toggleDecisionOption: ToggleDecisionOptionFn;
}

export function createDecisionOptionColumn<
  T extends DocDataGrid_ItemFragment &
    DecisionOptionButton_DocumentItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "decisionOption",
    headerName: options.headerName,
    width: 40,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      const item = params.row.item;
      if (item.isItemEliminated || !!item.decisionOptionElimination)
        return null;
      const parentRow = params.row.parentId
        ? (params.api.getRow(params.row.parentId) as
            | DocDataGridRow<T>
            | null
            | undefined)
        : null;
      if (parentRow?.type !== "decision") return null;
      return (
        <DataGridDecisionOptionCell
          item={item}
          toggleDecisionOption={options.toggleDecisionOption}
          disabled={!options.canEdit}
        />
      );
    },
  };
}
